// extracted by mini-css-extract-plugin
module.exports =  {"fullRow":"fullRow__7kH0S","pageTitle":"pageTitle__TqqQg","rightContent":"rightContent__JAGV2","workspace":"workspace__ltquv"};